import React, { createContext, useState, useContext, useEffect } from 'react';
import { en } from '../locales/en';
import { ar } from '../locales/ar';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(localStorage.getItem('app_lang') || 'ar');

    const translations = { en, ar };

    // ✅ تحويل t إلى دالة (Function) تأخذ Key وترجع النص المترجم
    const t = (key) => {
        if (translations[lang] && translations[lang][key]) {
            return translations[lang][key];
        }
        // Fallback للغة الإنجليزية ثم المفتاح نفسه
        if (en[key]) return en[key];
        return key;
    };

    const toggleLanguage = () => {
        const newLang = lang === 'en' ? 'ar' : 'en';
        setLang(newLang);
        localStorage.setItem('app_lang', newLang);
    };

    // تغيير اتجاه الصفحة حسب اللغة
    useEffect(() => {
        document.body.dir = lang === 'ar' ? 'rtl' : 'ltr';
    }, [lang]);

    return (
        <LanguageContext.Provider value={{ lang, setLang, toggleLanguage, isAr: lang === 'ar', t, tVal: t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLang = () => useContext(LanguageContext);